import { CartSheetTrigger } from '~/domains/cart/cart-sheet'
// import { HasExperiment } from '~/hooks/use-experiment'
import { FindACocoonBtn } from './find-a-cocoon-btn'
import { UserMenu } from './user-menu'

export const DesktopNav = () => {
	return (
		<div className='flex items-center'>
			<FindACocoonBtn />

			<div className='flex items-center gap-6 text-sm'>
				{/* <HasExperiment experimentId='carts-beta'> */}
				<CartSheetTrigger />
				{/* </HasExperiment> */}

				<UserMenu />
			</div>
		</div>
	)
}
